export function generateUniqueName(
  existingNames: Array<string> = [],
  prefix: string,
  {
    allowNoSuffix = false,
    addSpaceAfterPrefix = false,
  }: {allowNoSuffix?: boolean; addSpaceAfterPrefix?: boolean} = {}
): string {
  const nameMap: {[name: string]: boolean} = {};

  for (const name of Array.from(existingNames)) {
    nameMap[name] = true;
  }
  if (allowNoSuffix && !(prefix in nameMap)) {
    return prefix;
  }
  let i = allowNoSuffix ? 2 : 1;
  let nameWithPrefix = addSpaceAfterPrefix ? `${prefix} ${i}` : `${prefix}${i}`;
  while (nameWithPrefix in nameMap) {
    nameWithPrefix = addSpaceAfterPrefix ? `${prefix} ${i}` : `${prefix}${i}`;
    i++;
  }
  return nameWithPrefix;
}
